import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { claimDetailsCoreStyle } from './styles';
import { claimActions } from 'store';
import { Comments, CustomDelete, DetailItem, ModalFullTable, SelectActions } from 'components';
import { billApptBody, billApptHead, billDetailsList, billInfoList, claimPaymentTableBody, claimPaymentTableHead } from './constants';
import { commentModels, Images, KeyPurpose, PermissionList, RolePermission, useModal, useSecondaryModal } from 'utils';
import { PENDING_CLAIM } from '../constants';

const activeButtonStyle = {
    fontWeight: 700,
    borderBottom: '4px solid #FFCA33',
};

export const ReceivableBillTable = ({ currentId, defaultBill, from }) => {
    const { billClaimPmt, claimById } = useSelector((state) => ({
        billClaimPmt: state.claim.billClaimPmt,
        claimById: state.claim.claimById,
    }));
    const classes = claimDetailsCoreStyle();
    const [activeButton, setActiveButton] = useState('detail');
    const dispatch = useDispatch();
    const billById = defaultBill ? defaultBill : claimById?.bills?.find((i) => i?.id === currentId);
    const { close } = useModal();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { openSecondary, closeSecondary } = useSecondaryModal();
    const filteredList = billById?.appts?.filter((i) => !i?.removedFromClaimFlag);
    const [selectedList, setSelectedList] = useState([]);
    const DELETE_ACTION_TYPE =
        claimById?.status === PENDING_CLAIM && selectedList?.length === filteredList?.length ? 'DELETE_CLAIM' : 'REMOVE_APPT_FROM_CLAIM';

    useEffect(() => {
        if (billById) {
            dispatch(claimActions.bilClaimPmtTr(billById?.id));
            dispatch(claimActions.bilInvoicePmt([billById?.id]));
        }
    }, [billById]);

    const afterSuccess = () => {
        dispatch(claimActions.getClaimById(claimById?.id, 'noLoad'));
    };

    const handleChange = (type) => {
        setActiveButton(type);
    };

    const removeAppts = () => {
        const count = selectedList?.length || 0;
        const label = count === 1 ? 'appointment' : 'appointments';
        openSecondary(
            <CustomDelete
                innerText={'Remove'}
                text={`This will remove the selected ${label} from this claim.`}
                info={`Remove ${count === 1 ? 'Appointment' : 'Appointments'}?`}
                closeSecondaryModal={true}
                handleDel={() => {
                    if (claimById?.status === PENDING_CLAIM) {
                        if (selectedList?.length === filteredList?.length) {
                            dispatch(claimActions.deleteClaim({ claimIds: [claimById?.id] }));
                        } else {
                            dispatch(
                                claimActions.removeFromClaim(
                                    {
                                        apptIds: selectedList,
                                        reason: ' ',
                                    },
                                    claimById?.id,
                                    claimById?.status
                                )
                            );
                        }
                    } else {
                        dispatch(
                            claimActions.removeFromClaim(
                                {
                                    apptIds: selectedList,
                                    reason: ' ',
                                },
                                claimById?.id,
                                claimById?.status
                            )
                        );
                    }
                }}
                afterSuccess={() => {
                    setSelectedList([]);
                    closeSecondary();
                    if (selectedList?.length === filteredList?.length && claimById?.status === PENDING_CLAIM) {
                        navigate(`/claims`, { state: { tabType: info?.tabType } });
                    }
                }}
                actionType={DELETE_ACTION_TYPE}
                // body={
                //     <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                //         <img style={{ marginTop: '3px' }} src={Images.fileBlack} alt="icon" />
                //         <p>{claimById?.displayId}</p>
                //     </div>
                // }
            />
        );
    };

    const handleCheck = (ev, item, name) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (name === 'all' || name === 'selectAll') {
            let allList = filteredList?.length === selectedList?.length ? [] : filteredList?.map((i) => i?.id);
            setSelectedList(allList);
        } else {
            const list = [...selectedList];
            const uniqSet = new Set(list);

            if (!uniqSet.has(item?.id)) {
                list.push(item?.id);
            } else {
                list.indexOf(item?.id) !== -1 && list.splice(list.indexOf(item?.id), 1);
            }
            setSelectedList(list);
        }
    };

    return (
        <div style={{ width: '1280px', maxWidth: '100%', height: '80vh' }}>
            <div className={classes.recBillContainerStyle}>
                <div className={classes.recBillTitleStyle}>
                    <p>Bill ID:</p>
                    <p style={{ fontWeight: 400, marginLeft: 4 }}>{billById?.displayId}</p>
                </div>

                <div className={classes.billInfo}>
                    {billInfoList(billById)?.map(
                        (item, index) =>
                            item?.value && (
                                <div key={index} className={classes.billInfoItem}>
                                    <p>{item.title}</p>
                                    <p style={{ fontWeight: 400, width: '100%' }}>{item.value}</p>
                                </div>
                            )
                    )}
                </div>

                <div>
                    <div className={classes.buttonsTabWrapper}>
                        <button onClick={() => handleChange('detail')} style={activeButton === 'detail' ? { ...activeButtonStyle } : {}}>
                            Details
                        </button>
                        <button onClick={() => handleChange('claim')} style={activeButton === 'claim' ? { ...activeButtonStyle } : {}}>
                            Claim Payment Transaction
                        </button>
                        <button
                            onClick={() => handleChange('appointments')}
                            style={activeButton === 'appointments' ? { ...activeButtonStyle } : {}}>
                            Appointments
                        </button>
                        <button
                            onClick={() => handleChange('comments')}
                            style={activeButton === 'comments' ? { ...activeButtonStyle } : {}}>
                            <img src={Images.commentCircle} alt="comment" />
                        </button>
                    </div>

                    {activeButton === 'detail' && (
                        <div className={classes.billDetailsBox}>
                            {billDetailsList(billById)?.map(
                                (item, index) =>
                                    item?.value && (
                                        <Fragment key={index}>
                                            <DetailItem title={item?.title} value={item.value} background={item?.background} />
                                        </Fragment>
                                    )
                            )}
                        </div>
                    )}

                    {activeButton === 'claim' && (
                        <ModalFullTable
                            head={claimPaymentTableHead(from)}
                            body={claimPaymentTableBody(from)}
                            loadingType={'GET_BILL_CLAIM_PAYMENT_TRANSACTIONS'}
                            list={billClaimPmt?.txns}
                            noText={'claim payment transactions'}
                            activeRowId={''}
                            height={'auto'}
                        />
                    )}
                    {activeButton === 'appointments' && (
                        <ModalFullTable
                            head={billApptHead(claimById, from, handleCheck, filteredList, selectedList)}
                            body={billApptBody(classes, claimById, afterSuccess, from, close, handleCheck, filteredList, selectedList)}
                            list={billById?.appts}
                            noText={'appointments'}
                            activeRowId={''}
                            height={'auto'}
                        />
                    )}

                    {activeButton === 'comments' && (
                        <Comments
                            fromDetail={true}
                            resource={commentModels.Bill}
                            resourceId={billById?.id}
                            label={'Bill'}
                            width={700}
                            height={450}
                            attachmentPurpose={KeyPurpose.BILL_DOC}
                            enableAiImprove
                        />
                    )}
                </div>
            </div>

            {!!selectedList?.length && (
                <SelectActions
                    noSubmit={true}
                    selectInnetText={selectedList?.length === filteredList?.length ? 'Clear Selection' : 'Select All'}
                    actionType={DELETE_ACTION_TYPE}
                    selectedList={selectedList?.length}
                    selectAll={handleCheck}
                    removeSelected={() => setSelectedList([])}
                    renderOtherBtns={
                        RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) && (
                            <div className="flex-align-center" style={{ height: 30, gap: 8 }}>
                                <button onClick={removeAppts} className="selector-action-btn" style={{ width: '100%' }}>
                                    <img style={{ color: '#FF3D2F' }} src={Images.remove} alt="remove" />
                                    <p style={{ color: '#FF3D2F', fontWeight: 600 }}>Remove from Claim</p>
                                </button>
                            </div>
                        )
                    }
                />
            )}
        </div>
    );
};
